import { SERVICES_ICONS } from '../config'
import Corporate from '../ui/icons/Corporate'

export const getServiceIcon = (id: number): JSX.Element => SERVICES_ICONS[id - 1] || Corporate()
